import React, { ComponentProps, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import CobaltTag from '@cobalt/react-tag';

import { CasePriorityEnum, genCasePriorityMap } from './helper';

export interface CasePriorityTagProps {
  priority: CasePriorityEnum;
  size?: ComponentProps<typeof CobaltTag>['size'];
}

const Tag = styled(CobaltTag)<{ value: CasePriorityEnum }>`
  &.case-priority-tag-normal {
    color: var(--blue-700);
    background-color: var(--blue-300);
  }
`;

function CasePriorityTag(props: CasePriorityTagProps) {
  const { priority, size = 'small' } = props;

  const [t] = useTranslation();

  const casePriorityMap = useMemo(() => genCasePriorityMap(t), [t]);
  const casePriorityObj = useMemo(() => casePriorityMap[priority], [casePriorityMap, priority]);

  return (
    <Tag
      className={priority === CasePriorityEnum.Normal ? 'case-priority-tag-normal' : ''}
      size={size}
      color={casePriorityObj.color}
      value={priority}
    >
      {casePriorityObj.text}
    </Tag>
  );
}

export default CasePriorityTag;
